// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pYR5","rightAdornment":"Header_rightAdornment__DNRSn"};